module.exports = __webpack_public_path__ + "img/14.30ddd563.png";